// WaveUI.js
// UI component for displaying wave information

/**
 * Creates and manages the wave UI
 * Shows the current wave number and countdown timer for the next wave
 */
export function createWaveUI() {
    // Create main container
    const waveUIContainer = document.createElement('div');
    waveUIContainer.id = 'wave-ui-container';
    waveUIContainer.style.cssText = `
        position: fixed;
        top: 50px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        color: white;
        font-family: Arial, sans-serif;
        user-select: none;
        pointer-events: none;
        z-index: 1000;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    `;
    
    // Create wave number display
    const waveNumberDisplay = document.createElement('div');
    waveNumberDisplay.id = 'wave-number';
    waveNumberDisplay.style.cssText = `
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 5px;
    `;
    waveNumberDisplay.textContent = 'Wave: 1';
    
    // Create countdown display (for intermission)
    const countdownDisplay = document.createElement('div');
    countdownDisplay.id = 'wave-countdown';
    countdownDisplay.style.cssText = `
        font-size: 18px;
        opacity: 0.9;
        display: none;
    `;
    countdownDisplay.textContent = 'Next wave in: 10';
    
    // Create announcement display for wave start/end
    const announcementDisplay = document.createElement('div');
    announcementDisplay.id = 'wave-announcement';
    announcementDisplay.style.cssText = `
        font-size: 32px;
        font-weight: bold;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
        opacity: 0;
        transition: opacity 0.5s ease-in-out;
        pointer-events: none;
        user-select: none;
        z-index: 1001;
    `;
    
    // Add elements to container
    waveUIContainer.appendChild(waveNumberDisplay);
    waveUIContainer.appendChild(countdownDisplay);
    
    // Add container to document
    document.body.appendChild(waveUIContainer);
    document.body.appendChild(announcementDisplay);
    
    console.log('[WaveUI] Initialized');
    
    // Return methods for updating the UI
    return {
        /**
         * Update the wave number display
         * @param {number} waveNumber - Current wave number
         */
        updateWaveNumber: (waveNumber) => {
            waveNumberDisplay.textContent = `Wave: ${waveNumber}`;
        },
        
        /**
         * Update the countdown display
         * @param {number} seconds - Seconds until next wave
         * @param {boolean} isIntermission - Whether we're in intermission
         */
        updateCountdown: (seconds, isIntermission) => {
            const displaySeconds = Math.ceil(seconds);
            countdownDisplay.textContent = `Next wave in: ${displaySeconds}`;
            
            // Show countdown only during intermission
            countdownDisplay.style.display = isIntermission ? 'block' : 'none';
        },
        
        /**
         * Show wave announcement (wave start/end)
         * @param {string} message - Message to display
         * @param {number} duration - Duration to show message in ms
         */
        showAnnouncement: (message, duration = 3000) => {
            announcementDisplay.textContent = message;
            announcementDisplay.style.opacity = '1';
            
            setTimeout(() => {
                announcementDisplay.style.opacity = '0';
            }, duration);
        }
    };
}

// Add a wave started effect/animation
/**
 * Creates a visual effect when a new wave starts
 */
export function createWaveStartEffect() {
    // Create full-screen flash effect
    const flashOverlay = document.createElement('div');
    flashOverlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 0, 0, 0.2);
        pointer-events: none;
        z-index: 999;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
    `;
    
    document.body.appendChild(flashOverlay);
    
    // Flash the overlay
    flashOverlay.style.opacity = '1';
    
    // Fade out
    setTimeout(() => {
        flashOverlay.style.opacity = '0';
        
        // Remove after animation completes
        setTimeout(() => {
            flashOverlay.remove();
        }, 300);
    }, 300);
} 